import React, { Component } from "react";
import { Input, Label, Img } from "arv-reactcomponents";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { PAYMENTPAGE, Endpoints } from "npmlinks-constants";

class Cvv extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardCvv: "",
      cardCvvError: "",
      isValid: false,
    };
    this.handleCvvChange = this.handleCvvChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.cvvLengthCheck = this.cvvLengthCheck.bind(this);
    this.updateCvv = this.updateCvv.bind(this);
  }

  cvvLengthCheck(value, isValid, noError) {
    if (value && value.length < this.props.validCvvLength && !noError) {
      this.setState({
        cardCvv: value,
        cardCvvError: `${this.props.validCvvLength} digits, please`,
        isValid: false,
      });
      this.props.handleSubmit({ isValid: false, cardCvv: value });
    } else {
      this.setState({ cardCvv: value, cardCvvError: null, isValid });
      this.props.handleSubmit({ isValid, cardCvv: value });
    }
  }

  /**
   * handle the input entering of cvv
   * cvv length can be different based on credit card type
   * we can check based on event.target.value also instead of HTML5 constarint validation
   * @param event
   */
  handleCvvChange(event) {
    event.preventDefault();
    const validateCvvField = this.cvvFieldRef.getValidatedOutput(
      event.target.value,
    );
    const { isValid, value } = validateCvvField;
    let { errorMsg } = validateCvvField;
    if (this.props.cvvErrorMessage) {
      errorMsg = this.props.cvvErrorMessage;
    }
    if (!isValid) {
      this.setState({ cardCvv: "", cardCvvError: errorMsg, isValid });
      this.props.handleSubmit({ isValid, cardCvv: "" });
      return;
    }
    this.cvvLengthCheck(value, isValid);
  }
  updateCvv(event) {
    event.preventDefault();
    const validateCvvField = this.cvvFieldRef.getValidatedOutput(
      event.target.value,
    );
    const { isValid, value } = validateCvvField;
    this.cvvLengthCheck(value, isValid, true);
  }
  onFocus() {
    if (this.props.onFocus) {
      this.props.onFocus(this.props.cardPassed);
    }
  }

  render() {
    const { cardCvvError } = this.state;
    return (
      <div className="nw-creditcardcvv">
        <Label
          htmlFor="nw-paymentoption-cardcvv"
          className="nw-paymentoption-cardcvv"
        >
          CVV
        </Label>
        <Input
          className="nw-cvv-input nw-creditcard-input nw-cvv-passwordtype"
          id={`nw-paymentoption-cardcvv${this.props.passedId}`}
          type="tel"
          name={`cardCvv${this.props.passedId}`}
          value={this.state.cardCvv}
          ref={values => {
            this.cvvFieldRef = values;
          }}
          validateWithPattern={[
            {
              pattern: /^\d+$/,
              msg: PAYMENTPAGE.CARD_VALIDATION_MESSAGES.CVV_MISSING,
            },
          ]}
          maxLength={this.props.validCvvLength}
          onChange={this.handleCvvChange}
          onFocus={this.onFocus}
          required
        />
        <i className="icomoon-info nw-cvv-info">
          <Img
            className="nw-cvv-image"
            src={Endpoints.cvvImge}
            alt="cvv image"
          />
        </i>
        <div className="nw-paymentwallet-error" id="cardcvverror">
          {cardCvvError}
        </div>
      </div>
    );
  }
}

Cvv.defaultProps = {
  onFocus: null,
  cardPassed: {},
  cvvErrorMessage: "",
};

Cvv.propTypes = {
  passedId: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  validCvvLength: PropTypes.number.isRequired,
  cvvErrorMessage: PropTypes.string,
  onFocus: PropTypes.func,
  cardPassed: PropTypes.shape({}),
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: Cvv,
  component: Cvv,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PaymentWallet/CreditCard/Cvv/index.js